import React from 'react';
import { useI18n } from '../../i18n/I18nContext';
import { useAuth } from '../../hooks/useAuth';
import { useVendorLanguage } from '../../hooks/useVendorLanguage';
import LanguageSwitcher from '../LanguageSwitcher';

function Header(props) {
  var title = props.title;
  var onLogout = props.onLogout;
  
  var i18n = useI18n();
  var t = i18n.t;
  
  var auth = useAuth();
  var user = auth.user;
  
  var langContext = useVendorLanguage();
  var targetLanguage = langContext.targetLanguage;
  var supportedLanguages = langContext.supportedLanguages;
  var updatePreferences = langContext.updatePreferences;
  var loading = langContext.loading;

  function handleTargetLangChange(e) {
    updatePreferences({ targetLanguage: e.target.value });
  }

  return React.createElement('div', {
    style: { background: 'var(--primary)', color: 'white', padding: '16px' }
  },
    React.createElement('div', { className: 'container flex justify-between items-center' },
      React.createElement('h1', { style: { fontSize: '18px', fontWeight: '600' } }, title),
      React.createElement('div', { className: 'flex items-center gap-3' },
        // Show target language selector for vendors (in dual mode)
        user && user.role === 'vendor' && !loading && supportedLanguages.length > 0 &&
          React.createElement('select', {
            value: targetLanguage,
            onChange: handleTargetLangChange,
            style: {
              padding: '6px 10px',
              borderRadius: '6px',
              border: 'none',
              background: 'rgba(255,255,255,0.2)',
              color: 'white',
              fontSize: '13px',
              cursor: 'pointer'
            },
            title: 'Translation language'
          },
            supportedLanguages.map(function(lang) {
              return React.createElement('option', { 
                key: lang.code, 
                value: lang.code,
                style: { color: 'black' }
              }, lang.native_name);
            })
          ),
        // General UI language switcher
        React.createElement(LanguageSwitcher),
        // Logout button
        React.createElement('button', {
          onClick: onLogout,
          style: {
            background: 'transparent',
            border: 'none',
            color: 'white',
            fontSize: '14px',
            cursor: 'pointer'
          }
        }, t('common.logout'))
      )
    )
  );
}

export default Header;
